module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "health-insurance-card-yes.dcb0c878.png";